<template>
  <Alert
    class="bg-green-900! border-green-900! text-white! cursor-pointer"
    :icon="DacrMarkIcon"
    arrow
    @click="handleUpgradeToPro"
  >
    <div class="font-medium">Dacr Pro Membership required</div>
    <div><slot /></div>
  </Alert>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { Alert } from '@dacr/library'
import { DacrMarkIcon } from '@dacr/icons'
import { closeAllModals } from '@/shared/dialogs/modals'
import { closeAllSheets } from '@/shared/dialogs/sheets'

const router = useRouter()

const handleUpgradeToPro = () => {
  router.push('/upgrade')
  closeAllModals()
  closeAllSheets()
}
</script>
